"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type {
  DailyDemandPoint,
  DailyRefLine,
  DailyAnnotation,
} from "./DailyDemandChart.impl";

export const DailyDemandChart = dynamicChart(
  () => import("./DailyDemandChart.impl").then((m) => m.DailyDemandChart),
  384,
);
